import { ProductCardDTO, ProductDTO } from "tekkeys-common";

export class PriceCalculator {
  private readonly discountDaysLeft: number;
  private readonly product: ProductDTO | ProductCardDTO;
  private readonly productPrice?: number;
  constructor(input: ProductDTO|ProductCardDTO, discountDaysLeft: number,price?:number) {
    // Normalize input
    this.product = input;
    this.discountDaysLeft = discountDaysLeft;
    this.productPrice = price? price : this.product?.price;
  }

  calculatePrice(): number {
    if (this.discountDaysLeft > 0) {
      if (this.product?.discountType === 'FIX') {
        return this.productPrice - this?.product?.discount;
      } else if (this.product?.discountType === 'PERCENTAGE') {
        return this.productPrice * (1 - this.product?.discount);
      }
    }

    return this.productPrice;
  }

  displayDiscount(): string {   
    if (this.discountDaysLeft > 0) {
      if (this.product.discountType === 'FIX') {
        return `-${this.product.discount}€`;
      } else if (this.product.discountType === 'PERCENTAGE') {
        return `-${this.product.discount * 100 }%`;
      }
    }

    return `${this.productPrice}€`;
  }
}
